import { IBus } from "@sg-widgets/platform-api/lib/bus";
import {
  initializeWidgetConfiguration,
  SgWidget,
  WidgetConfiguration,
  WidgetConfigurationProvider,
  WithGlobalCss,
} from "@sgwt-widget/core";
import { h } from "preact";
import { emit, props } from "skatejs";
import { ComboBox } from "../common/components/form-elements";
import { MakeGenericAttributeApiCall } from "../common/generic/generic-api";
import {
  IGenericAttributeRequest,
  IGenericAttributeValues,
} from "../common/generic/generic-attribute-types";
import { IHeaders } from "../common/utils/types";
import { generateUniqueId } from "../common/utils/uniqueId";

interface ISelectSingleProps {
  attribute: string;
  idReturnValue?: string;
  indicator: string;
  includeKpi?: string;
  userSelection: { [attribute: string]: string };
  userEmail: string;
  filters?: string;
}

export class CprSelectSingle extends SgWidget<ISelectSingleProps> {
  public static is = "cpr-select-single";

  public static props = {
    attribute: props.string,
    filters: props.string,
    idReturnValue: props.string,
    includeKpi: props.string,
    indicator: props.string,
    userEmail: props.string,
    userSelection: props.object,
  };

  public render(intraprops: ISelectSingleProps) {
    const params = this.constructParameters(intraprops);
    const getItems = () =>
      MakeAtrributeCall(
        params.headers,
        params.attribute,
        params.filters,
        params.indicator,
        params.includeKpi,
        this.widgetConfiguration
      ).then((v: IGenericAttributeValues) => (v.values ? v.values : []));

    const onChange = (value: string) => {
      let newValue = {};
      newValue = intraprops.idReturnValue
        ? value
          ? { [intraprops.idReturnValue]: value }
          : {}
        : value
        ? { [intraprops.attribute]: value }
        : {};
      intraprops.userSelection = newValue;
      emit(this, "cpr-select-single--filter-changed", { detail: newValue });
    };

    return (
      <WidgetConfigurationProvider
        widgetConfiguration={this.widgetConfiguration}
      >
        <WithGlobalCss>
          <ComboBox
            getItems={getItems}
            defaultItem={params.selectedItem}
            onChange={onChange}
          />
        </WithGlobalCss>
      </WidgetConfigurationProvider>
    );
  }

  public constructParameters(intraprops: ISelectSingleProps): any {
    const headers = {
      uiscreen: `${(this.constructor as any).is}-${intraprops.attribute}`,
    };
    const attribute = intraprops.attribute ? intraprops.attribute : "";
    const selectedValToUse = intraprops.idReturnValue
      ? intraprops.idReturnValue
      : attribute;
    const selectedItem =
      intraprops.userSelection && intraprops.userSelection[selectedValToUse]
        ? intraprops.userSelection[selectedValToUse]
        : "";
    const indicator = intraprops.indicator ? intraprops.indicator : "sc";
    const includeKpi =
      intraprops.includeKpi !== undefined
        ? !(intraprops.includeKpi === "false")
        : true;
    const filters =
      intraprops.filters && intraprops.filters.length > 0
        ? intraprops.filters
        : "";
    return {
      attribute,
      filters,
      headers,
      includeKpi,
      indicator,
      selectedItem,
    };
  }
}

initializeWidgetConfiguration(CprSelectSingle);
customElements.define(CprSelectSingle.is, CprSelectSingle);

async function MakeAtrributeCall(
  headers: IHeaders,
  attribute: string,
  filters: string,
  indicator: string,
  includeKpi: boolean,
  configuration: WidgetConfiguration
): Promise<IGenericAttributeValues> {
  const emptyfilter = `-${attribute}:`;
  const filtersIncludeEmpty =
    filters.length > 0 ? `${filters},${emptyfilter}` : emptyfilter;
  const request: IGenericAttributeRequest = {
    filters: filtersIncludeEmpty,
    includeKpi,
  };
  return MakeGenericAttributeApiCall(
    headers,
    indicator,
    attribute,
    request,
    configuration,
    generateUniqueId()
  );
}
